import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteMaintenanceFailMode } from '../../../../actions';

const MaintenanceFailModeDeleteButton = ({
  dispatchDeleteMaintenanceFailMode,
  maintenanceFailModeId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () =>
    dispatchDeleteMaintenanceFailMode({ maintenanceFailModeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

MaintenanceFailModeDeleteButton.propTypes = {
  dispatchDeleteMaintenanceFailMode: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  maintenanceFailModeId: PropTypes.number.isRequired,
};

MaintenanceFailModeDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteMaintenanceFailMode: deleteMaintenanceFailMode,
};

export default connect(
  null,
  mapDispatchToProps,
)(MaintenanceFailModeDeleteButton);
